import { createContext } from "react";

/**
 * Absolute index of the selected EPG channel, read by the column headers.
 * As a prop it made the TV grid's `renderChannelGroup` depend on the selection,
 * so every horizontal focus move re-rendered every mounted channel group.
 */
const EPGSelectedChannelIndexContext = createContext<number | null>(null);

export default EPGSelectedChannelIndexContext;
